import FileSaver from 'file-saver';

export class toExcel {

    saveAsExcelFile(buffer: any, fileName: string): void {
        let EXCEL_TYPE =
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data: Blob = new Blob([buffer], {
          type: EXCEL_TYPE,
        });
        FileSaver.saveAs(
          data,
          fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
        );
      }
      export(data: any, excelFileName: string) {
        import('xlsx').then((xlsx) => {
          const worksheet = xlsx.utils.json_to_sheet(data);
          const workbook = {
            Sheets: { data: worksheet },
            SheetNames: ['data'],
          };
          const excelBuffer: any = xlsx.write(workbook, {
            bookType: 'xlsx',
            type: 'array',
          });
          this.saveAsExcelFile(excelBuffer, excelFileName);
        });
      }
      exportToExcel(src:[], name:string) {
        this.export(src,name);
      }
}
